import { useContext } from 'react';
import { TourContext } from '../components/onboarding/TourProvider';
import type { TourContextValue } from '../components/onboarding/types';

export function useTour(): TourContextValue {
  const ctx = useContext(TourContext);
  if (!ctx) {
    throw new Error('useTour must be used inside <TourProvider>');
  }
  return ctx;
}
